import script from "./FeaturedItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./FeaturedItem.vue?vue&type=script&setup=true&lang=ts"

import "./FeaturedItem.vue?vue&type=style&index=0&id=a27ce7ba&lang=scss"

const __exports__ = script;

export default __exports__